export enum MixpanelCategory {
  USER = 'Usuario',
  API = 'API',
  APP = 'Aplicación'
}
